import React, { Component } from 'react';
import Helmet from 'react-helmet';

import { Section } from '../Section';
import { Container } from '../Containers';
import { Menu } from './Menu';
import { mediumMargin, gutter } from '../../margins';
import { h4 } from '../../fontSizes';

export class MenuSection extends Component {
  constructor(props) {
    super(props);

    this.state = { active: 0 };

    this.navigateToMenu.bind(this);
  }

  navigateToMenu(index) {
    this.setState({ active: index });
  }

  render() {
    const {
      bigImage,
      heading,
      menus,
      marketingActivated,
      marketing,
      scrollToRef,
      active,
      slug,
    } = this.props;
    const menu = menus[this.state.active];
    return [
      active && (
        <Helmet key="helmet">
          <meta
            property="og:url"
            content={`https://www.styrelsen.nu/${slug}`}
          />
          <meta property="og:type" content="restaurant.menu" />
        </Helmet>
      ),
      <Section
        key="section"
        heading={heading}
        image={bigImage}
        marketing={marketingActivated && marketing}
        scrollToRef={scrollToRef}
      />,
      menus.length > 1 && (
        <Container
          key="navigation"
          css={`
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            margin: 0;
          `}
        >
          {menus.map(({ navigationText }, index) => (
            <a
              css={`
                margin: 0 calc(${gutter} / 2) ${mediumMargin};
                font-size: ${h4};
                font-weight: 400;
                ${this.state.active === index && 'text-decoration: underline;'};
              `}
              href={'#' + encodeURIComponent(navigationText)}
              key={navigationText}
              onClick={ev => ev.preventDefault() || this.navigateToMenu(index)}
            >
              {navigationText}
            </a>
          ))}
        </Container>
      ),
      <Menu
        key={menu.navigationText || 'menu'}
        parts={menu.menu}
        description={menu.description}
      />,
    ];
  }
}



// WEBPACK FOOTER //
// ./app/components/MenuSection/MenuSection.js